import React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonAdd } from '@modules/layout/atoms';
import { ListToolbar } from '@modules/layout/moleculas';
import { LapsListFilter } from '@modules/lap/moleculas';
import { LapCreateForm, LapFormModal } from '@modules/lap/organisms';

type LapsListToolbarProps = {
    canFilter: boolean;
    canCreate: boolean;
};

const LapsListToolbar = (props: LapsListToolbarProps): React.ReactElement => {
    const { canFilter, canCreate } = props;

    const { t } = useTranslation(['lap']);

    const [openLapCreateFormModal, setLapCreateFormModal] = React.useState(false);

    const handleOpenLapCreateFormModal = (): void => setLapCreateFormModal(true);
    const handleCloseLapCreateFormModal = (): void => setLapCreateFormModal(false);

    return (
        <ListToolbar>
            {canCreate ? (
                <>
                    <ButtonAdd onClick={handleOpenLapCreateFormModal}>
                        {t('lap:actions.add_lap')}
                    </ButtonAdd>

                    <LapFormModal
                        title={t('lap:add_lap.title')}
                        open={openLapCreateFormModal}
                        onClose={handleCloseLapCreateFormModal}
                    >
                        <LapCreateForm onCancel={handleCloseLapCreateFormModal} />
                    </LapFormModal>
                </>
            ) : null}

            {canFilter ? <LapsListFilter /> : null}
        </ListToolbar>
    );
};

export { LapsListToolbar };
